<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" :disabled="disabled">
      <el-row>
        <el-form-item label="流水号名称" prop="serialName">
          <el-input
            v-model="formData.serialName"
            placeholder="请输入流水号名称"
          >
          </el-input>
        </el-form-item>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="当前编号">
            <el-input
              v-model="formData.currentNo"
              placeholder="系统自动生成"
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="流水号类型" prop="serialType">
            <el-select v-model="formData.serialType">
              <el-option label="BILL" value="BILL" />
              <el-option label="ID" value="ID" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="增长方式">
            <el-select v-model="formData.isAddType">
              <el-option label="递增" value="A" />
              <el-option label="日递增" value="B" />
              <el-option label="月递增" value="C" />
              <el-option label="年递增" value="D" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="日期格式">
            <el-select
              v-model="formData.dateType"
              placeholder="请选择日期格式"
              style="width:100%"
            >
              <el-option label="年月日(yyyyMMdd)" value="yyyyMMdd" />
              <el-option label="年月(yyyyMM)" value="yyyyMM" />
              <el-option label="年(yyyy)" value="yyyy" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="特殊前缀">
            <el-input
              v-model="formData.specialPrefix"
              placeholder="请输入特殊前缀"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="单据前缀">
            <el-input
              v-model="formData.billPrefix"
              placeholder="请输入单据前缀"
              v-bind:disabled="billPrefixDisabled"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="数字长度">
            <el-input-number
              v-model="formData.numberLength"
              placeholder="请输入流水号中的数字长度"
              controls-position="right"
              style="width:100%"
              :max="2147483647"
              :min="0"
              :step-strictly="true"
              :step="1"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="总长度">
            <el-input-number
              v-model="formData.totalLength"
              placeholder="请输入流水号总长度"
              controls-position="right"
              style="width:100%"
              :disabled="true"
            >
            </el-input-number>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
          <el-form-item label="启用状态" prop="isActive">
            <el-radio-group v-model="formData.isActive">
              <el-radio label="Y">已启用</el-radio>
              <el-radio label="N">未启用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-form-item label="流水号说明">
          <el-input
            type="textarea"
            v-model="formData.serialDescription"
            placeholder="请输入流水号说明"
          >
          </el-input>
        </el-form-item>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button @click="save()" type="primary" size="small">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    disabled: Boolean,
    ruleCode: String,
    isDisabled: Boolean,
  },
  data() {
    return {
      backDialogVisible: false,
      formData: { isActive: 'Y', totalLength: 0 },
      rules: {
        serialName: [
          { required: true, message: '请输入流水号名称', trigger: 'blur' },
        ],
        serialType: [
          { required: true, message: '请选择流水号类型', trigger: 'change' },
        ],
        isActive: [
          { required: true, message: '请选择是否启用', trigger: 'change' },
        ],
      },
    }
  },
  computed: {
    billPrefixDisabled() {
      return this.formData.serialType === 'ID'
    },
  },
  mounted() {
    this.getData()
  },
  watch: {
    /**
     * 侦听formDate里某些属性，计算流水号总长度
     */
    'formData.serialType'() {
      this.updateTotalLength()
    },
    'formData.numberLength'() {
      this.updateTotalLength()
    },
    'formData.billPrefix'() {
      this.updateTotalLength()
    },
    'formData.specialPrefix'() {
      this.updateTotalLength()
    },
    'formData.dateType'() {
      this.updateTotalLength()
    },
  },
  methods: {
    /**
     * 计算流水号总长度
     */
    updateTotalLength() {
      if (this.formData.serialType === 'ID') {
        this.formData.billPrefix = null
      }

      this.formData.totalLength = 0
      if (this.formData.numberLength) {
        this.formData.totalLength += this.formData.numberLength
      }
      if (this.formData.billPrefix) {
        this.formData.totalLength += this.formData.billPrefix.length
      }
      if (this.formData.specialPrefix) {
        this.formData.totalLength += this.formData.specialPrefix.length
      }
      if (this.formData.dateType) {
        this.formData.totalLength += this.formData.dateType.length
      }
    },
    getData() {
      if (!this.ruleCode) return
      this.$api
        .sysSerialNoRuleDetailApi({
          ruleCode: this.ruleCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      let loadingInstance = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.$api
        .sysSerialNoRuleSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
